/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Service } from './Service'
import { ServiceFromJSON, ServiceFromJSONTyped, ServiceToJSON } from './Service'

/**
 *
 * @export
 * @interface GetServices200ResponseData
 */
export interface GetServices200ResponseData {
  /**
   * Корневые категории услуг с вложенными элементами (один уровень вложенности)
   * @type {Array<Service>}
   * @memberof GetServices200ResponseData
   */
  services: Array<Service>
}

/**
 * Check if a given object implements the GetServices200ResponseData interface.
 */
export function instanceOfGetServices200ResponseData(
  value: object
): value is GetServices200ResponseData {
  if (!('services' in value) || value['services'] === undefined) return false
  return true
}

export function GetServices200ResponseDataFromJSON(
  json: any
): GetServices200ResponseData {
  return GetServices200ResponseDataFromJSONTyped(json, false)
}

export function GetServices200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetServices200ResponseData {
  if (json == null) {
    return json
  }
  return {
    services: (json['services'] as Array<any>).map(ServiceFromJSON),
  }
}

export function GetServices200ResponseDataToJSON(
  value?: GetServices200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    services: (value['services'] as Array<any>).map(ServiceToJSON),
  }
}
